import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from '@scentregroup/shared/link'
import { Paragraph, Container } from '@scentregroup/ui'
import Article from '../article'
import ResponsiveImage from '../responsive-image'
import style from './index.module.scss'

const FullWidth = ({
  imageUrl,
  link,
  body,
  title,
  topic,
  lazyLoad = true,
  ...articleProps
}) => (
  <Container centred className={classNames(style.FullWidth)} type="large">
    {imageUrl && (
      <Link to={link}>
        <ResponsiveImage
          lazyLoad={lazyLoad}
          className={style.image}
          desktopImageUrl={imageUrl}
          mobileImageUrl={imageUrl}
          mobileRatio="standard"
          desktopRatio="standard"
          numberOfItems={1}
          alt={articleProps.heading}
        />
      </Link>
    )}
    <Article
      className={style.Article}
      superheading={topic}
      link={link}
      heading={title}
      {...articleProps}
    >
      <Paragraph>{body}</Paragraph>
    </Article>
  </Container>
)

FullWidth.propTypes = {
  imageUrl: PropTypes.string,
  link: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  topic: PropTypes.string,
  title: PropTypes.string,
  articleProps: PropTypes.object,
  lazyLoad: PropTypes.bool,
}

export default FullWidth
